<template>
  <div>
    <vm-table
        ref="vmTable"
        height="65vh"
        :filter.sync="filter"
        module="basic"
        method="post"
        url="materials/pageList1"
        @select="selectTest">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="关键词">
            <el-input v-model.trim="filter.filter" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="materialName" label="名称"/>
      <el-table-column prop="materialNO" label="型号"/>
      <el-table-column prop="variableName" label="产品类别"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="100px">
        <template slot-scope="scope">
          <el-button type="primary" @click="handleUploadOpen(scope.row.materialID)">上传图片</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <el-dialog title="上传图片" :visible.sync="dialogVisible" width="30%">
      <vm-upload-file v-model="imageUrl" filename.sync="" accept=".jpg,.png" @input="handUploadSuccess"/>
      <span slot="footer">
        <el-button @click="handleUploadClose">取消</el-button>
        <el-button :loading="uploadLoading" type="primary" @click="handleSubmit">上传</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import VmUploadFile from "@/components/VmUploadFile";
  export default {
    name: "MESManage",
    components: { VmTable, VmSearch, VmUploadFile },
    data() {
      return {
        editAuth: this.$auth(681),
        idList: "",
        filter: {
          filter: "",
        },
        uploadLoading: false,
        dialogVisible: false,
        uploadImgId: "",
        imageUrl: "",
      };
    },
    mounted() {
      this.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      selectTest(selection) {
        this.idList = selection;
      },
      // 上传图片相关
      handUploadSuccess(url) {
        this.imageUrl = url;
      },
      handleSubmit() {
        this.uploadLoading = true;
        this.$http.save("basic", "materialImages", {
          materialID: this.uploadImgId,
          filePath: this.imageUrl,
          isDefault: false,
          filePathType: 10,
        })
          .then(() => {
            this.submitLoading = false;
            this.dialogVisible = false;
            this.$message.success("上传成功");
          })
          .finally(() => {
            this.uploadLoading = false;
          });
      } , 
      handleUploadOpen(id) {
        this.dialogVisible = true;
        this.uploadImgId = id;
      },
      handleUploadClose() {
        this.dialogVisible = false;
        this.uploadLoading = false;
        this.imageUrl = "";
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
